module.exports = __webpack_public_path__ + "img/gps-right.5ba453ed.png";